import { Button } from "antd";
import { useContext } from "react";
import Address from "./Address";
import { Web3Context } from "src/contexts";

export default function Account() {
  const modalButtons = [];
  const {
    address,
    logoutOfWeb3Modal,
    loadWeb3Modal,
    web3Modal,
    injectedProvider,
    blockExplorer,
  } = useContext(Web3Context);
  const minimized = undefined;
  if (web3Modal) {
    if (web3Modal.cachedProvider) {
      modalButtons.push(
        <Button
          key="logoutbutton"
          style={{
            verticalAlign: "top",
            marginLeft: 8,
            marginTop: 4,
            backgroundColor: "transparent",
          }}
          onClick={logoutOfWeb3Modal}
          className="bordered-button account-button"
        >
          logout
        </Button>
      );
    } else {
      modalButtons.push(
        <Button
          key="loginbutton"
          style={{
            verticalAlign: "top",
            marginLeft: 8,
            marginTop: 4,
            backgroundColor: "transparent",
          }}
          /* type={minimized ? "default" : "primary"}     too many people just defaulting to MM and having a bad time */
          onClick={loadWeb3Modal}
          className="bordered-button account-button"
        >
          Connect
        </Button>
      );
    }
  }

  const display = minimized ? (
    ""
  ) : (
    <span>
      {address ? (
        <Address
          address={address}
          ensProvider={injectedProvider}
          blockExplorer={blockExplorer}
        />
      ) : (
        ""
      )}
    </span>
  );

  return (
    <div
      className="account-bar"
      style={{ position: "fixed", right: 0, top: 0, padding: 10, zIndex: 3000 }}
    >
      {display}
      {modalButtons}
    </div>
  );
}
